
define(
	'Dev.RestrictBackSlash.RestrictBackSlash'
,   [
		'underscore',
		'Utils',
		'ItemsSearcher.View'
	]
,   function (
		_,
		Utils, 
		ItemsSearcherView,
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			
			var layout = container.getComponent('Layout');
			_.extend(ItemsSearcherView.prototype, {
					onKeyDown: function onKeyDown(e) {
						// Prevent backslash from being entered into the search field
						if (e.key === '\\' || e.which === 220 || e.keyCode === 220) {
							e.preventDefault();

							this.showSearchError('Backslash (\\) is not allowed in search.');

							return false;
						}

						// Hide the error when another valid key is pressed
						this.hideSearchError();

						const current_text = this.$searchElement.typeahead('val');

						if (
							this.options.selectedItem &&
							current_text !== this.getItemDisplayName(this.options.selectedItem, this.options.query)
						) {
							this.options.selectedItem = null;

							this.trigger('itemSelected', {
								selectedItem: null,
								collection: this.collection.models,
								currentQuery: this.options.query
							});
						}

						// @event keyDown
						this.trigger(
							'keyDown',
							// @class ItemsSearcher.View.KeyDown.Properties
							{
								// @property {Array<Item.Model>} collection
								collection: this.collection.models,
								// @property {jQueryEvent} eventObject
								eventObject: e,
								// @property {String} currentQuery
								currentQuery: this.getCurrentQuery()
							}
						);
						// @class ItemsSearcher.View
					},
					showSearchError: function (message) {
						var $errorMessage = this.$('.search-error-message');

						if (!$errorMessage.length) {
							$errorMessage = jQuery('<div class="search-error-message"></div>');
							this.$searchElement.after($errorMessage);
						}

						$errorMessage.text(message).show();
					},
					hideSearchError: function () {
						this.$('.search-error-message').hide();
					}
				});

		}
	};
});
